import React, { Component } from 'react';
import "../../css/RegistroFirmaIframe.css";
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import CrearFirmaElectronica from './CrearFirmaElectronica';
import CrearFirmaIcon from '../../assets/CrearfirmaICO.svg';
import FirmaWhiteIcon from '../../assets/firma_white.svg';
//import FirmaSubidaIcon from '../../assets/FirmaSUBIDA(ESPOL).svg';
import "../../css/Modal.css";  // Importamos el archivo CSS del modal
import MenuUsuario from './MenuUsuario';
import jwt from 'jwt-decode'
import Cookies from 'js-cookie';
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';
import { ReactComponent as FirmaSubidaIcon } from '../../assets/FirmaSUBIDA(ESPOL).svg';
import CenteredWrapper from '../components/CenteredWrapper.js';

export default class RegistroFirmaIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firmas: [],  // Inicializado vacío para que las filas se agreguen dinámicamente
      modalVisible: false,  // Estado para controlar la visibilidad del modal
      canCreateFirma: true,
      msgVisible: false,            // Modal de mensajes (info/error)
      msgTitle: '',
      msgBody: '',
      nombre_completo: '',
      loading: true,
      primeravezpag:true,
      token:"",
      meses: [
              "enero", "febrero", "marzo", "abril", "mayo", "junio",
              "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
      ]
    };
  }


  waitForToken = (retries = 20) => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        const token = sessionStorage.getItem("access_token");
        if (token) {
          clearInterval(interval);
          resolve(token);
        } else if (retries-- <= 0) {
          clearInterval(interval);
          reject("Token no disponible");
        }
      }, 300);
    });
  };


  componentDidMount() {
    //this.handleloadfirmas();
    this.initTokenListener();
    console.log("did mount");
  }

  initTokenListener = () => {
    // ✅ Si el token ya existe, carga directo
    // console.log("antes de capturar el token");

    const token = sessionStorage.getItem("access_token");
    // console.log("initTokenListener");
    if (token) {
      this.loadFirmas(token);
      return;
    }

    // 🧭 Espera al evento SOLO UNA VEZ
    window.addEventListener(
      "entra-token-ready",
      () => {
        console.log("✅ Token Entra ID listo");
        this.loadFirmas();
      },
      { once: true }
    );
  };

  handleTokenReady = () => {
    // console.log("Luego de Token Entra ID listo, se ejecuta handleTokenReady");

    const token = sessionStorage.getItem("access_token");
    // console.log("Desde cuentatest. token es: "+ token)
    if (!token) {
      this.openMsgModal(
        "Sesión no válida",
        "No se encontró un token de acceso. Inicia sesión nuevamente."
      );
      return;
    }

    this.loadFirmas(token);
  };

  loadFirmas = async (token) => {
   this.setState({ loading: true, canCreateFirma: false });
    console.log("load firmas");
    try {
    const response = await fetch(
      `${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ObtenerFirmaActivaByPersona`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    const data = await response.json();

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      const dia = date.getDate();
      const mesTexto = this.state.meses[date.getMonth()];
      const año = date.getFullYear();
      return `${dia}/${mesTexto}/${año}`;
    };

    const listaFirmas = Array.isArray(data?.listData) && data.listData.length > 0
      ? data.listData
      : data?.data
        ? [data.data]
        : [];

    const firmas = listaFirmas.map((firma) => ({
      firma: <FirmaSubidaIcon width={30} />,
      fechaSubida: formatDate(firma.fechaemision),
      fechaCaducidad: formatDate(firma.fechavencimiento),
    }));

    const currentDate = new Date();
    const canCreateFirma =
      firmas.length === 0 ||
      firmas.every(f => {
        const [dia, mesTexto, anio] = f.fechaCaducidad.split('/');
        const meses_temp = {
          enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
          julio: 6, agosto: 7, septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11
        };
        const mes = meses_temp[mesTexto.toLowerCase()];
        const cad = new Date(anio, mes, dia);
        return isNaN(cad) || cad < currentDate;
      });

    this.setState({ firmas, canCreateFirma });

  } catch (err) {
    this.openMsgModal(
      "No se pudieron cargar las firmas",
      "Ocurrió un problema al obtener la información."
    );
  } finally {
    this.setState({ loading: false });
  }
};
/*handleloadfirmas() {
    this.setState({
      loading: true,
      canCreateFirma: false
    });
    window.addEventListener("entra-token-ready", () => {
      console.log("✅ Token Entra ID listo");

      const token = sessionStorage.getItem("access_token");  // Obtiene el token desde sessionStorage
      if (!token) {
        this.openMsgModal(
          "Sesión no válida",
          "No se encontró un token de acceso. Inicia sesión nuevamente para continuar."
        );
        return;
      }
      fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ObtenerFirmaActivaByPersona`, { //ObtenerFirmasActivasByPersona
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            // intenta leer el cuerpo para mostrar un mensaje más útil
            let errText = '';
            try { errText = await response.text(); } catch (_) { }
            throw new Error(errText || `Error ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          const formatDate = (dateString) => {
            if (!dateString) return "";

            const date = new Date(dateString);

            

            const dia = date.getDate();
            const mesTexto = this.state.meses[date.getMonth()];
            const año = date.getFullYear();

            return `${dia}/${mesTexto}/${año}`;
          };

          const listaFirmas = Array.isArray(data?.listData) && data.listData.length > 0
            ? data.listData
            : data?.data
              ? [data.data] // convierte el único objeto en array
              : [];

          // Comprobar si existe alguna firma válida
         const firmas = listaFirmas.map((firma) => ({
            firma: <FirmaSubidaIcon width={30} />,
            fechaSubida: formatDate(firma.fechaemision),
            fechaCaducidad: formatDate(firma.fechavencimiento),
          }));
          const currentDate = new Date();
          const canCreateFirma = firmas.length === 0
            ? true
            : firmas.every(f => {
              const [dia, mesTexto, anio] = f.fechaCaducidad.split('/');
              const meses_temp = {
                enero: 0,
                febrero: 1,
                marzo: 2,
                abril: 3,
                mayo: 4,
                junio: 5,
                julio: 6,
                agosto: 7,
                septiembre: 8,
                octubre: 9,
                noviembre: 10,
                diciembre: 11,
              };
              const mes = meses_temp[mesTexto.toLowerCase()] + 1; // months are 0-based in JS

              const cad = new Date(`${anio}-${mes}-${dia}`);
              return isNaN(cad) || cad < currentDate;
            });
          this.setState({ firmas, canCreateFirma });
        })
        .catch((error) => {
          this.openMsgModal(
            "No se pudieron cargar las firmas",
            "Ocurrió un problema al obtener la información. Por favor, intenta nuevamente más tarde."
          );
        })
        .finally(() => {
          this.setState({ loading: false });
        });
      });
  };
*/




  openMsgModal = (title, body) => {
    this.setState({ msgVisible: true, msgTitle: title, msgBody: body });
  };

  closeMsgModal = () => {
    this.setState({ msgVisible: false, msgTitle: '', msgBody: '' });
  };

  handleCrearFirma = () => {
    this.setState({ modalVisible: true });
  };
  handleCrearFirma = () => {
    if (!this.state.canCreateFirma) {
      this.openMsgModal(
        "Acción no permitida",
        "Ya tienes una firma vigente. Solo podrás crear una nueva cuando la actual caduque."
      );
      return;
    }
    this.setState({ modalVisible: true });
  };

  closeCrearModal = () => {
    this.setState({ modalVisible: false });
  };
  handleloadfirmas = () =>{
    window.location.reload();
  }


  render() {
    const { modalVisible, msgVisible, msgTitle, msgBody, loading } = this.state;
    // 👉 PRIMERA VALIDACIÓN: si está cargando, retorna solo el spinner
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: 20 }}>
          <ComponenteSpinner />
        </div>
      );
    }
  return (
    <div>
      <div className="registrofirmaIframe-container">
      
        {!this.state.canCreateFirma ? (
          <>
            {!modalVisible && (
              <div className="row-registrofirmaIframe-title">
                <p className="registrofirmaIframe-title">
                  <img src={FirmaWhiteIcon} alt="Crear Firma" className="crear-firma-icon" />
                  <b>FIRMAS REGISTRADAS</b>
                </p>
              </div>
            )}

            {/* Modal de MENSAJES (info/error) */}
            {msgVisible && (
              <div className="modal-background">
                <div className="modal-container">
                  <div className="modal-header1">
                    <h3 className="h3">{msgTitle}</h3>
                    <button className="modal-close" onClick={this.closeMsgModal}>
                      &times;
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>{msgBody}</p>
                  </div>
                  <div className="modal-actions">
                    <button
                      className="modal-primary-btn"
                      onClick={this.closeMsgModal}
                    >
                      Aceptar
                    </button>
                  </div>
                </div>
              </div>
            )}

            {!modalVisible && (
              <div>
                <p className='row-registrofirma-content'>Usted ya tiene una firma ESPOL generada el {
                  (() => {
                    const [dia, mes, anio] = this.state.firmas[0].fechaSubida.split("/");
                    return `${dia} de ${mes} del ${anio}`;
                  })()
                }, cuya fecha de expiración es el {
                  (() => {
                    const [dia, mes, anio] = this.state.firmas[0].fechaCaducidad.split("/");
                    return `${dia} de ${mes} del ${anio}`;
                  })()
                }.</p>
                <p className='row-registrofirma-content'>Si ha olvidado su contraseña tiene que volver a crear una nueva firma en: 
                  <a 
                    href="/crearfirma" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link-primary m-1"
                  >
                    Crear Firma
                  </a>
                </p>  
              </div> 
            )}
          </>
        ) : (
          <div>
            <h3 className="h3">CREAR FIRMA ELECTRÓNICA</h3>

            <CrearFirmaElectronica
              modalVisible={modalVisible}
              setModalVisible={(value) => this.setState({ modalVisible: value })}
              handleloadfirmas={this.handleloadfirmas}
            />
          </div>
        )}
      </div>
    </div>
    );
  }
}

